import { render } from "./RiskAndCategory.vue?vue&type=template&id=75498b98"
import script from "./RiskAndCategory.vue?vue&type=script&lang=js"
export * from "./RiskAndCategory.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__